import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { getAutoQuotesApi, getAutoQuotesSchedulesApi } from 'api/automatedQuotes';
import { BackdropCircular, Breadcrumb } from 'components';
import useLocalStorageTableCells from 'hooks/useLocalStorageTableCells';
import ViewColumn from 'helpers/ViewColumn';
import { defaultScheduleTableCells } from '../helpers';
import { useStyles } from '../styles';
import QuoteScheduleTableRow from './QuoteScheduleTableRow';


const AutomatedQuoteSchedules = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { headTableCells, setHeadTableCells } = useLocalStorageTableCells('defaultScheduleTableCells', defaultScheduleTableCells);
  const {
    autoQuoteSchedules,
    autoQuotes,
    autoQuotesSchedulesListLoading,
    autoQuotesLoading
  } = useSelector((state: IReduxState) => state.automatedQuotes);
  const { quoteProductsLoading } = useSelector((state: IReduxState) => state.quote);

  useEffect(() => {
    if (!autoQuoteSchedules?.length) {
      getAutoQuotesSchedulesApi({dispatch});
    }

    if (!autoQuotes?.length) {
      getAutoQuotesApi({ dispatch });
    }
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Automated Quotes', path: '/automated-quotes'},
            { name: 'Schedules'}
          ]}
        />
        <div className={classes.card}>
          <Card className="mt-5 pt-5">
            <div className={`py-3 ${classes.toolbarContainer} flex items-center justify-end`}>
              <ViewColumn storageKey="depositTableCells" tableCells={defaultScheduleTableCells} setHeadTableCells={setHeadTableCells} />
            </div>
            <div className="table-container">
              <TableContainer>
                <Table aria-label="collapsible table" className={classes.table}>
                  <TableHead>
                    {headTableCells.map((cell, index) => {
                      if (!cell.display) {
                        return null;
                      }

                      return (
                        <TableCell
                          key={index}
                          align={cell.align}
                          className={`min-w-${cell.width}`}
                        >
                          {cell.label}
                        </TableCell>
                      );
                    })}
                    <TableCell align="center" className="min-w-180">Actions</TableCell>
                  </TableHead>
                  <TableBody>
                    {!autoQuoteSchedules?.length ?
                      <TableRow>
                        <TableCell colSpan={Object.keys(headTableCells).length + 1} align="center">
                          No matching quotes found.
                        </TableCell>
                      </TableRow>
                      :
                      autoQuoteSchedules.map((quote) => (
                        <QuoteScheduleTableRow
                          key={quote._id}
                          quote={quote}
                          headTableCells={headTableCells}
                        />
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Card>
        </div>
      </div>
      <BackdropCircular loading={autoQuotesSchedulesListLoading || quoteProductsLoading || autoQuotesLoading} />
    </div>
  );
};

export default AutomatedQuoteSchedules;
